import { COMMON_ALERT_OPEN } from '../actions/commonActions';

export const handleErrors = (message, dispatch) => {
  if (typeof message === 'object') {
    Object.keys(message).map((key) => { 
      if (typeof message[key] === 'object' ) {
        let tmp = message[key]
        Object.keys(tmp).map((tmpKey) => {
          dispatch({ 
            type: COMMON_ALERT_OPEN, alert: {
               open: true,
               type: 'error',
               message: tmp[tmpKey]
             } 
           });
        })
      } else {
        dispatch({ 
          type: COMMON_ALERT_OPEN, alert: {
             open: true,
             type: 'error',
             message: message[key]
           } 
         });
      }

    })
   } else {

   dispatch({ 
     type: COMMON_ALERT_OPEN, alert: {
        open: true,
        type: 'error',
        message: message
      } 
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/helpers/error.js